import agile from "./agile";
import eventManagement from "./eventManagement";
import marketing from "./marketing";
import projectManagement from "./projectManagement";
// import construction from "./construction";
// import general from "./general";

export default [
  {
    id: "projectManagement",
    label: "Project Management",
    icon: "pm",
    template: projectManagement,
    category: "pm",
    creator: "Timeline.App",
    description: "A template for managing projects"
  },
  {
    id: "agile",
    label: "Agile Project",
    icon: "appPencil",
    template: agile,
    category: "pm",
    creator: "Timeline.App",
    description: "A template for managing agile projects, including Epics, Stories, and Tasks"
  },
  {
    id: "eventManagement",
    label: "Event Management",
    icon: "calendarStar",
    template: eventManagement,
    category: "pm",
    creator: "Timeline.App",
    description: "A template for managing agile projects, including Epics, Stories, and Tasks"
  },
  {
    id: "marketing",
    label: "Marketing",
    icon: "social",
    template: marketing,
    category: "pm",
    creator: "Timeline.App",
    description: "A template for managing agile projects, including Epics, Stories, and Tasks"
  }
  // {
  //   id: "construction",
  //   label: "Construction",
  //   icon: "historical",
  //   template: construction
  // },
  // {
  //   id: "general",
  //   label: "General",
  //   icon: "pm",
  //   template: general
  // }
];
